import { useBattlePassDetails, useBattlePassTiers, } from 'root/src/client/v2/battlePass/features/BattlePassDetails/hooks/useBattlePassDetails';
import { TierBadge } from 'root/src/client/v2/battlePass/components/TierBadge';
import RadioButton from 'root/src/client/web/base/RadioButton';
import { defaultDropFilter } from 'root/src/client/v2/_pages/battle-pass-details/constants';
import { useBattlePassDropMnemonicId, useBattlePassTier, } from 'root/src/client/v2/battlePass/features/BattlePassDetails/contexts/battlePassDetails.context';
import { BlackLayout } from 'root/src/client/v2/common/layouts/BlackLayout';
import { TitleBattlePass } from 'root/src/client/v2/battlePass/components/TitleBattlePass';
import * as Carousel from 'root/src/client/v2/common/components/Carousel/Carousel';
export const BattlePassDetailsFilters = () => {
    var _a;
    const battlePassDetails = useBattlePassDetails();
    if (battlePassDetails.isLoading) {
        return <SkeletonBattlePassFilters />;
    }
    return (<BlackLayout>
			<TitleBattlePass description={(_a = battlePassDetails === null || battlePassDetails === void 0 ? void 0 : battlePassDetails.battlePass) === null || _a === void 0 ? void 0 : _a.description}/>
			<BattlePassTiersFilter />
			<BattlePassDropsFilter />
		</BlackLayout>);
};
export const BattlePassTiersFilter = () => {
    const { tiers } = useBattlePassTiers();
    const { tier, setTier, activeCreatorTier } = useBattlePassTier();
    return (<div className="flex w-[80%] lg:w-[60%] justify-center m-auto gap-2">
			<div className="overflow-hidden">
				<Carousel.Root axis="x" dragFree>
					<Carousel.Container className="flex gap-4 no-scrollbar my-4">
						{tiers.map((tierFilter) => {
            const isActive = tier === tierFilter.tier;
            const isLocked = activeCreatorTier < tierFilter.tier - 1;
            return (<TierBadge tier={tierFilter.tier} key={tierFilter.label} label={tierFilter.label} isActive={isActive} onClick={() => setTier(tierFilter.tier)} isLocked={isLocked}/>);
        })}
					</Carousel.Container>
				</Carousel.Root>
			</div>
		</div>);
};
export const BattlePassDropsFilter = () => {
    const battlePassDetails = useBattlePassDetails();
    const { dropMnemonicIds, onDropMnemonicIds } = useBattlePassDropMnemonicId();
    return (<div className="mt-4 flex m-auto gap-4">
			<p className="text-teal text-lg font-mono">DROPS: </p>
			<div className="flex flex-wrap gap-3">
				{[defaultDropFilter, ...battlePassDetails.drops].map((drop) => {
            const isActive = dropMnemonicIds.includes(drop.mnemonicId);
            return (<RadioButton key={drop.id} id={drop.id} label={drop.campaignName.toUpperCase()} checked={isActive} onClick={() => onDropMnemonicIds(drop.mnemonicId)} className="flex justify-center items-center text-lg text-primary data-[active=false]:hover:opacity-75"/>);
        })}
			</div>
		</div>);
};
export const SkeletonBattlePassFilters = () => {
    return (<BlackLayout>
			<div className="flex flex-col justify-center items-center">
				<div className="animate-skeleton-loading bg-dark-2 w-1/6 h-[60px] rounded-lg my-3"/>
				<div className="animate-skeleton-loading bg-dark-2 w-3/6 h-[100px] rounded-lg"/>
				<div className="animate-skeleton-loading bg-dark-2 w-2/6 h-[60px] rounded-lg my-3"/>
			</div>
		</BlackLayout>);
};
